import { Collapse } from "bootstrap";
import bootstrap from "bootstrap";
//Page animation
const scrollElements = document.querySelectorAll(".js-scroll");

const elementInView = (el: Element, dividend = 1) => {
  const elementTop = el.getBoundingClientRect().top;

  return (
    elementTop <=
    (window.innerHeight || document.documentElement.clientHeight) / dividend
  );
};

const elementOutofView = (el: Element) => {
  const elementTop = el.getBoundingClientRect().top;

  return (
    elementTop > (window.innerHeight || document.documentElement.clientHeight)
  );
};

const displayScrollElement = (element: Element) => {
  element.classList.add("scrolled");
};

const hideScrollElement = (element: Element) => {
  element.classList.remove("scrolled");
};

const handleScrollAnimation = () => {
  scrollElements.forEach((el) => {
    if (elementInView(el, 1.25)) {
      displayScrollElement(el);
    } else if (elementOutofView(el)) {
      hideScrollElement(el);
    }
  });
};

window.addEventListener("scroll", () => {
  handleScrollAnimation();
});
handleScrollAnimation();

/* ====== SCROLL TO TOP SCRIPT ======  */
var scrollToTopBtn = document.querySelector(".scrollToTopBtn");
var rootElement = document.documentElement;

function handleScroll() {
  // Do something on scroll - 0.15 is the percentage the page has to scroll before the button appears
  var scrollTotal = rootElement.scrollHeight - rootElement.clientHeight;
  if (rootElement.scrollTop / scrollTotal > 0.15) {
    // Show button
    scrollToTopBtn?.classList.add("showBtn");
  } else {
    // Hide button
    scrollToTopBtn?.classList.remove("showBtn");
  }
}

function scrollToTop() {
  // Scroll to top logic
  rootElement.scrollTo({
    top: 0,
    behavior: "smooth",
  });
}
scrollToTopBtn?.addEventListener("click", scrollToTop);
document.addEventListener("scroll", handleScroll);

//Teaser equeal height
var matchHeight = (function () {
  return {
    match: function () {
      var groupName = Array.prototype.slice.call(
        document.querySelectorAll("[data-match-height]")
      );
      var groupHeights = {} as unknown as { [key: string]: number };

      for (var item of groupName) {
        var data = item.getAttribute("data-match-height");

        item.style.minHeight = "auto";

        if (groupHeights.hasOwnProperty(data)) {
          Object.defineProperty(groupHeights, data, {
            value: Math.max(groupHeights[data], item.offsetHeight),
            configurable: true,
            writable: true,
            enumerable: true,
          });
        } else {
          groupHeights[data] = item.offsetHeight;
        }
      }

      var groupHeightsMax = groupHeights;

      Object.getOwnPropertyNames(groupHeightsMax).forEach(function (value) {
        var elementsToChange = document.querySelectorAll(
          `[data-match-height='${value}']`
        );

        for (var i = 0; i < elementsToChange.length; i++) {
          const changeElement = elementsToChange[i] as HTMLElement;
          changeElement.style.height =
            Object.getOwnPropertyDescriptor(groupHeightsMax, value)?.value +
            "px";
        }
      });
    },

    eventListeners: function () {
      window.addEventListener("resize", () => {
        this.match();
      });
    },

    init: function () {
      this.eventListeners();
      this.match();
    },
  };
})();

document.addEventListener("DOMContentLoaded", function () {
  matchHeight.init();
});

//Scroll mouse
function calculateHeight(this: any) {
  const scrollAmount = 350; // Adjust this value to control how much to scroll

  // Get the current scroll position
  const currentScrollPosition =
    window.scrollY || document.documentElement.scrollTop;

  // Calculate the new scroll position by adding the scrollAmount
  const newScrollPosition = currentScrollPosition + scrollAmount;

  // Scroll to the new position
  window.scrollTo(0, newScrollPosition);
}

const scrollBtn = document.getElementById("scroll-btn");
if (scrollBtn) {
  scrollBtn.addEventListener("click", calculateHeight, false);
}

const accordionHeaders = document.querySelectorAll(
  ".accordion .accordion-item .accordion-header"
);

accordionHeaders.forEach((header) => {
  header.addEventListener("click", function () {
    const openAccordion = Collapse.getInstance(
      document.querySelector(".accordion .accordion-collapse.collapse.show")
    );

    if (openAccordion && openAccordion._element !== this.nextElementSibling) {
      openAccordion.hide();
    }
  });
});
const printPage = document.querySelector(".print-page");
if (printPage) {
  printPage.addEventListener("click", function () {
    window.print();
  });
}
